import type { IconProps } from './types';
import './icons.css';

export default function CopyTwo({
  width,
  height,
  className = '',
}: IconProps): React.JSX.Element {
  return (
    <svg
      width={width || 25}
      height={height || 25}
      viewBox="0 0 25 25"
      xmlns="http://www.w3.org/2000/svg"
      className={`icon icon-copy ${className || ''}`}
      fill="none"
    >
      <g
        stroke="currentColor"
        fill="transparent"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        clipPath="url(#copy-a)"
      >
        <path d="M20.5 9h-9a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2-2v-9a2 2 0 0 0-2-2Z" />
        <path d="M5.5 15h-1a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
      </g>
      <defs>
        <clipPath id="copy-a">
          <path fill="#fff" d="M.5 0h24v24H.5z" />
        </clipPath>
      </defs>
    </svg>
  );
}
